import { PackageCategory } from '../enums/package-category.enum';

export enum BillingFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HALFYEARLY = 'HALFYEARLY'
  //YEARLY = 'YEARLY'
}

export interface Feature {
  title: string;
  active: boolean;
}

export interface PackageDisplayConfigLocal {
  packageCategory: PackageCategory;
  description: string;
  isMostPopular?: boolean;
  features: Feature[];
  bonus?: string;
}

export const PACKAGES_DISPLAY_CONFIG: Partial<Record<PackageCategory, Omit<PackageDisplayConfigLocal, 'pricing'>>> = {
  [PackageCategory.LITE]: {
    packageCategory: PackageCategory.LITE,
    description: 'Für kleine Teams, die regelmäßig Designpower brauchen.',
    features: [
      { title: '0,5-fache Power', active: true },
      { title: '7i7® Plattform', active: true },
      { title: '100+ Designleistungen', active: true },
      { title: 'Unbegrenzte Anfragen', active: true },
      { title: 'Fester Ansprechpartner', active: true },
      { title: 'Video Editing & Motion Design', active: false },
      { title: 'Strategie-Team', active: false }
    ]
  },
  [PackageCategory.BASIC]: {
    packageCategory: PackageCategory.BASIC,
    description: 'Für kleine Teams, die regelmäßig Designpower brauchen.',
    features: [
      { title: '1-fache Power', active: true },
      { title: '7i7® Plattform', active: true },
      { title: '100+ Designleistungen', active: true },
      { title: 'Unbegrenzte Anfragen', active: true },
      { title: 'Fester Ansprechpartner', active: true },
      { title: 'Video Editing & Motion Design', active: false },
      { title: 'Strategie-Team', active: false }
    ]
  },
  [PackageCategory.PRO]: {
    packageCategory: PackageCategory.PRO,
    description: 'Für Teams, die mehrere Projekte parallel steuern möchten.',
    isMostPopular: true,
    features: [
      { title: 'Doppelte Power', active: true },
      { title: '7i7® Plattform', active: true },
      { title: '100+ Designleistungen', active: true },
      { title: 'Unbegrenzte Anfragen', active: true },
      { title: 'Fester Ansprechpartner', active: true },
      { title: 'Video Editing & Motion Design', active: true },
      { title: 'Strategie-Team', active: false }
    ]
    //bonus: 'Unbegrenzte Anzahl an KI-Credits'
  }
  /*[PackageCategory.ENTERPRISE]: {
    packageCategory: PackageCategory.ENTERPRISE,
    description: 'Für Unternehmen, die ein komplettes externes Design Department brauchen.',
    features: [
      '4 Aufträge zur Zeit',
      '100+ Designleistungen',
      '7i7® flow Plattform',
      'Deutsches Designteam',
      'Unbegrenzte Revisionen',
      'Videobearbeitung',
      'Motion Design'
    ]
  }*/
};

export const BILLING_FREQUENCY_OPTIONS = [
  {
    value: BillingFrequency.MONTHLY,
    label: 'Monatlich'
  },
  {
    value: BillingFrequency.QUARTERLY,
    label: 'Quartalsweise'
    //discount: '-26%'
  },
  {
    value: BillingFrequency.HALFYEARLY,
    label: 'Halbjährlich'
    //discount: '-30%'
  }
  /*{
    value: BillingFrequency.YEARLY,
    label: 'Jährlich'
    //discount: '-30%'
  }*/
];
